import { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { t } from 'ttag';

import { socialFeed, socialSavedFeed } from '@urls';
import { ProfileSocialPostsFeed } from '@components/profile/ProfileSocialPostsFeed';

import { useProfileSocialPostsSavedQuery } from './gql/graphql.v5.generated';


export const ProfileSocialPostsSavedContainer = () => {
  const { data: postsData, networkStatus, fetchMore } = useProfileSocialPostsSavedQuery({
    context: {
      v5: true,
      batch: true,
    },
    notifyOnNetworkStatusChange: true,
  });

  const pageInfo = postsData?.me?.postsSaved?.pageInfo;

  const handleLoadMore = useCallback(async () => {
    if (pageInfo?.hasNextPage && networkStatus === NetworkStatus.ready) {
      await fetchMore({
        variables: {
          after: pageInfo?.endCursor,
        },
      });
    }
  }, [fetchMore, networkStatus, pageInfo?.endCursor, pageInfo?.hasNextPage]);

  const posts = useMemo(() => {
    const resultPosts = postsData?.me?.postsSaved.edges
      .map(({ node }) => node.post)
      .filter((post) => post.mediasUrls.length) || [];

    return resultPosts;
  }, [postsData?.me?.postsSaved.edges]);

  const emptyTitle = t`Тут з'являться ваші збережені пости зі Стрічки. Зберігайте пости, 
  до яких хочете повернутись або які вас надихають`;

  const emptyLink = {
    title: t`До Стрічки`,
    pathname: socialFeed,
  };

  return (
    <ProfileSocialPostsFeed
      posts={posts}
      isLoading={networkStatus === NetworkStatus.loading}
      hasNextPage={!!pageInfo?.hasNextPage}
      emptyTitle={emptyTitle}
      emptyLink={emptyLink}
      getPostUrl={() => generatePath(socialSavedFeed)}
      onLoadMore={handleLoadMore}
    />
  );
};
